module.exports = __webpack_public_path__ + "img/warning.4ed1a1ce.svg";